import { Box, Button, Grid } from "@mui/material";
import Header from "../../../components/Header";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import PanToolIcon from "@mui/icons-material/PanTool";
import SecurityDataGrid from "../../../components/dataGridSecurity";
import { ReactNotifications } from "react-notifications-component";
import TiresIAExplain from "../contents";
import TiresiaDataGrid from "../../../components/TiresiaDataGrid";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

function buildPayload(search, tz) {
  const q = new URLSearchParams(search);
  let dateFrom, dateTo;

  if (q.get("clickedData")) {
    dateFrom = dayjs.tz(q.get("clickedData"), tz).startOf("hour");
    dateTo = dateFrom.endOf("hour").millisecond(0);
  } else if (q.get("advtimeStamp")) {
    dateFrom = dayjs.tz(q.get("advtimeStamp"), tz).startOf("day");
    dateTo = dayjs.tz(q.get("advtimeStamp"), tz).endOf("day").millisecond(0);
  } else if (q.get("dateFrom") && q.get("dateTo")) {
    dateFrom = dayjs.tz(q.get("dateFrom"), tz);
    dateTo = dayjs.tz(q.get("dateTo"), tz).endOf("day").millisecond(0);
  } else {
    dateFrom = dayjs().tz(tz).subtract(1, "hour");
    dateTo = dayjs().tz(tz);
  }

  return {
    tipo: 2,
    dateFrom,
    dateTo,
    detail: q.get("details") || "",
    exact_detail: q.get("exact_details") || "",
    ipSource: q.get("ipSource") || "",
    ipDestination: q.get("ipDestination") || "",
    isPrivateSource: q.get("isPrivateSource"),
    isPrivateDestination: q.get("isPrivateDestination"),
  };
}

const Alert = ({ aiView }) => {
  const [content, setContent] = useState([]);
  const [explain, setExplain] = useState(false);
  const [message, setMessage] = useState("");
  const [coinvIp, setCoinvIp] = useState();
  const [suppDialog, setSuppDialog] = useState(false);
  const location = useLocation();
  const tz = sessionStorage.getItem("timezone") || "Europe/Amsterdam";
  const [payload] = useState(() => buildPayload(location.search, tz));

  const [maxCardHeight, setMaxCardHeight] = useState("1000px");
  useEffect(() => {
    const calc = () => {
      const h = window.innerHeight;
      setMaxCardHeight(`${h - h * 0.22}px`);
    };
    calc();
    window.addEventListener("resize", calc);
    return () => window.removeEventListener("resize", calc);
  }, []);

  return (
    <Box m="20px">
      <ReactNotifications />
      <Grid container>
        <Grid size={12} sx={{ display: "flex", justifyContent: "space-between" }}>
          <Header
            sx={{ width: { xs: "40vw", md: "" } }}
            title="Alert Reports"
            subtitle=""
            desc="LOGs with medium-impact details are present here. They can also be searched using the LIVE SEARCH BAR.
                If gray in color, they notify movement but not of particular significance. If yellow or orange in color, on the other hand, they indicate movements that require attention.
                They, finally, can be Filtered or Exported.
                NOTE: Only 4000 records are currently visible. To see more specific records properly use the date to search."
          />
          {!explain && (
            <Button
              variant="outlined"
              startIcon={<PanToolIcon fontSize="small" />}
              onClick={() => setSuppDialog(!suppDialog)}
              sx={{
                alignSelf: "flex-start",
                px: 2, py: 0.8, borderRadius: 2, fontWeight: 700, fontSize: "0.78rem", letterSpacing: "0.04em",
                color: "#449095", borderColor: "rgba(69,144,149,0.5)", backgroundColor: "rgba(69,144,149,0.06)",
                "&:hover": { borderColor: "#449095", backgroundColor: "rgba(69,144,149,0.14)" },
                width: { xs: "60vw", md: "auto" },
              }}
            >
              Suppress logs
            </Button>
          )}
        </Grid>
        <Grid size={12}>
          {aiView ? (
            <TiresiaDataGrid tipo={2} />
          ) : explain ? (
            <Box sx={{ flexGrow: 1, overflow: "hidden", padding: "20px" }}>
              <TiresIAExplain
                setMessage={setMessage}
                setViewExplain={setExplain}
                message={message}
                coinvIp={coinvIp}
                content={content}
                maxCardHeight={maxCardHeight}
              />
            </Box>
          ) : (
            <SecurityDataGrid
              tipo={2}
              tableKey="alert"
              passedPayload={payload}
              setMessage={setMessage}
              setCoinvIp={setCoinvIp}
              setContent={setContent}
              suppDialog={suppDialog}
              setSuppDialog={setSuppDialog}
              setViewExplain={setExplain}
            />
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default Alert;
